/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InflationProgramLife
 */
export interface InflationProgramLife {
    /**
     * 
     * @type {Date}
     * @memberof InflationProgramLife
     */
    anniversaryDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    canUserEditSettings: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    inflationIncreaseOfferFlag: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    inflationIncreaseFlag: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    independentIncreaseOfferFlag: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    independentIncreaseFlag: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    indexOptionOfferFlag: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    indexOptionFlag: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InflationProgramLife
     */
    isProcessingInflation: boolean;
}

/**
 * Check if a given object implements the InflationProgramLife interface.
 */
export function instanceOfInflationProgramLife(value: object): value is InflationProgramLife {
    if (!('anniversaryDate' in value) || value['anniversaryDate'] === undefined) return false;
    if (!('canUserEditSettings' in value) || value['canUserEditSettings'] === undefined) return false;
    if (!('inflationIncreaseOfferFlag' in value) || value['inflationIncreaseOfferFlag'] === undefined) return false;
    if (!('inflationIncreaseFlag' in value) || value['inflationIncreaseFlag'] === undefined) return false;
    if (!('independentIncreaseOfferFlag' in value) || value['independentIncreaseOfferFlag'] === undefined) return false;
    if (!('independentIncreaseFlag' in value) || value['independentIncreaseFlag'] === undefined) return false;
    if (!('indexOptionOfferFlag' in value) || value['indexOptionOfferFlag'] === undefined) return false;
    if (!('indexOptionFlag' in value) || value['indexOptionFlag'] === undefined) return false;
    if (!('isProcessingInflation' in value) || value['isProcessingInflation'] === undefined) return false;
    return true;
}

export function InflationProgramLifeFromJSON(json: any): InflationProgramLife {
    return InflationProgramLifeFromJSONTyped(json, false);
}

export function InflationProgramLifeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InflationProgramLife {
    if (json == null) {
        return json;
    }
    return {
        
        'anniversaryDate': (new Date(json['anniversaryDate'])),
        'canUserEditSettings': json['canUserEditSettings'],
        'inflationIncreaseOfferFlag': json['inflationIncreaseOfferFlag'],
        'inflationIncreaseFlag': json['inflationIncreaseFlag'],
        'independentIncreaseOfferFlag': json['independentIncreaseOfferFlag'],
        'independentIncreaseFlag': json['independentIncreaseFlag'],
        'indexOptionOfferFlag': json['indexOptionOfferFlag'],
        'indexOptionFlag': json['indexOptionFlag'],
        'isProcessingInflation': json['isProcessingInflation'],
    };
}

export function InflationProgramLifeToJSON(json: any): InflationProgramLife {
    return InflationProgramLifeToJSONTyped(json, false);
}

export function InflationProgramLifeToJSONTyped(value?: InflationProgramLife | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'anniversaryDate': ((value['anniversaryDate']).toISOString().substring(0,10)),
        'canUserEditSettings': value['canUserEditSettings'],
        'inflationIncreaseOfferFlag': value['inflationIncreaseOfferFlag'],
        'inflationIncreaseFlag': value['inflationIncreaseFlag'],
        'independentIncreaseOfferFlag': value['independentIncreaseOfferFlag'],
        'independentIncreaseFlag': value['independentIncreaseFlag'],
        'indexOptionOfferFlag': value['indexOptionOfferFlag'],
        'indexOptionFlag': value['indexOptionFlag'],
        'isProcessingInflation': value['isProcessingInflation'],
    };
}

